












import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import * as _ from "lodash";
import { inventoryCollection, contactsCollection } from "../db";
import * as firebase from "firebase/app";

@Component({})
export default class EquipmentCustomerEdit extends Vue {
  @Getter contacts;

  get formatCustomers() {
    return this.contacts.map((x) => {
      return this.formatCustomer(x);
    });
  }

  formatCustomer(contact) {
    let textArr = [contact.company, "-", contact.firstName, contact.lastName];
    textArr = textArr.filter((x) => x != "");
    if (textArr[0] == "-") {
      textArr.splice(0, 1);
    }
    if (textArr[textArr.length-1] == "-") {
      textArr.splice(textArr.length-1, 1);
    }
    const text = textArr.join(" ");

    return {
      text: text,
      id: contact.id,
    };
  }

  @Prop({ required: true })
  public item: any;

  @Prop({ required: true })
  public label: any;

  @Prop({ required: true })
  public value: any;

  private currentCustomer: any = null;

  created() {
    if (this.item[this.value] != undefined) {
      this.currentCustomer = this.formatCustomer(this.item[this.value]);
    }
  }

  async change(contact) {
    const obj = {};
    if (contact != undefined) {
      obj[this.value] = contactsCollection.doc(contact.id);
    } else {
      obj[this.value] = firebase.firestore.FieldValue.delete();
    }
    await inventoryCollection.doc(this.item.id).update(obj);
  }
}
